export const requestToJSON = <ReturnType = unknown>(
  promisedResponse: Promise<Response>
): Promise<ReturnType> => promisedResponse.then((response) => response.json());
